import React from "react";
import SVGShip1 from "../../Misc/SvgIcons/SVGShip1";
import IndexTile from "../Index/IndexTile";
export default function ShipList(props) {
  let ships = props.ships || [];
  return (
    <>
      <div className="d-flex align-items-center justify-content-center mh100">
        <div className="container">
          <h3>Выберите судно:</h3>
          <div className="row mt-5">
            {ships.map((ship) => (
              <IndexTile
                key={ship.id}
                link={`/ship/${ship.id}`}
                icon={<SVGShip1 />}
                iconColor="primary"
                title={ship.name}
                description={ship.description}
                className="col-lg-4 col-6"
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
